import React from "react";
import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: "75%",
  },
}));

const EmptyTimeslots = () => {
  const classes = useStyles();

  return (
    <FormControl
      variant="outlined"
      className={classes.formControl}
      style={{ marginTop: "1.5em" }}
    >
      No available slots for the selected date
    </FormControl>
  );
};

export default EmptyTimeslots;
